<template>
  <div class="entries-history-wrapper" id="entriesHistoryWrapper">
    <div class="">
      <div class="">
        <div
          class="card border-0 shadow table-scroll-entries"
          :key="index"
          v-for="(entryList, day, index) in entriesToDisp"
          style="padding-top: 15px"
        >
          <h5 class="table-subtitle date-title-entries" style="">
            {{ day }} ({{
              decimalToHoursAndMinutes(
                entryList.reduce((a, b) => a + b.Duration, 0),
              )
            }})
          </h5>
          <table
            class="table table-borderless table-entry-home"
            id="entriesTable"
          >
            <thead>
              <tr>
                <th
                  v-if="renderType === 'client'"
                  scope="col"
                  class="align-middle text-header-table"
                >
                  Owner
                </th>
                <th
                  v-if="renderType === 'home'"
                  scope="col"
                  class="align-middle text-header-table"
                >
                  Client Name
                </th>
                <th class="align-middle text-header-table-sm" scope="col">
                  Duration
                </th>
                <th
                  class="align-middle text-header-table"
                  scope="col"
                  style="width: 15% !important"
                >
                  Project-Task
                </th>
                <th class="align-middle text-header-table" scope="col">
                  Campaign ID
                </th>
                <th
                  class="align-middle text-header-table"
                  v-if="renderType === 'home'"
                  scope="col"
                >
                  Total Time spent
                </th>
                <th class="align-middle text-header-table-sm" scope="col">
                  Jira Id
                </th>
                <th class="align-middle text-header-table-sm" scope="col">
                  Entity
                </th>
                <th
                  class="align-middle text-header-table description-cell"
                  style="width: 25% !important"
                  scope="col"
                >
                  Description
                </th>
                <th class="align-middle text-header-table" scope="col">
                  Product Name
                </th>
                <th class="align-middle text-header-table" scope="col">
                  Duplicated from
                </th>
                <!-- <th class="align-middle">Credit Used</th> -->
                <th class="align-middle text-header-table-sm" scope="col">
                  Man Days
                </th>
              </tr>
            </thead>
            <tbody v-if="renderType === 'client'">
              <tr
                v-for="(entry, entryIndex) in entryList"
                :key="entryIndex"
                class="container-row"
              >
                <th scope="row" class="align-middle text-table">
                  {{ entry.Owner ? entry.Owner : "" }}
                </th>
                <td class="align-middle text-table">
                  <span>{{ decimalToHoursAndMinutes(entry.Duration) }}</span>
                </td>
                <td
                  class="align-middle text-table"
                  style="width: 15% !important"
                >
                  {{ entry.ProjectTask }}
                </td>
                <td class="align-middle text-table">{{ entry.TestId }}</td>
                <td class="align-middle text-table">{{ entry.JiraID }}</td>
                <td class="align-middle text-table">{{ entry.EntityName }}</td>
                <td
                  class="align-middle text-table"
                  style="width: 40% !important"
                >
                  {{ entry.Description }}
                </td>
                <td class="align-middle text-table">{{ entry.ProductName }}</td>
                <td class="align-middle text-table">
                  {{ entry.Duplicate !== 0 ? entry.Duplicate : "" }}
                </td>
                <!-- <td class="align-middle">{{ entry.credit_use }}</td> -->
                <td class="align-middle text-table">
                  {{ entry.ManDays !== 0 ? entry.ManDays : "" }}
                </td>
                <td v-if="isMobile">
                  <!-- make burger button to display  -->
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#entriesButtontModal"
                    class="btn btn-light"
                    @click="loadData(day, entryIndex, entry)"
                  >
                    ...
                  </button>
                </td>
                <td
                  class="align-middle"
                  style="
                    width: 75px;
                    width: 70px !important;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else
                >
                  <font-awesome-icon
                    icon="edit"
                    class="edit-button button-light me-2"
                    v-if="!isUserKam"
                    @click="
                      startEntryEdit(day, entryIndex, 'client');
                      goToForm();
                    "
                    color="transparent"
                  />
                  <font-awesome-icon
                    icon="trash-alt"
                    class="delete-button button-light"
                    v-if="!isUserKam"
                    @click="deleteEntry(entry, 'client')"
                    color="transparent"
                  />
                  <font-awesome-icon
                    icon="copy"
                    class="copy-button button-light ms-2"
                    v-if="!isUserKam"
                    @click="
                      duplicateEntry(day, entryIndex, 'client');
                      goToForm();
                    "
                    color="transparent"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-if="renderType === 'home'">
              <tr
                v-for="(entry, entryIndex) in entryList"
                :key="entryIndex"
                class="container-row"
              >
                <th
                  scope="row"
                  class="align-middle text-table clickable"
                  @click="$router.push(`/client/${entry.ClientID}`)"
                >
                  {{ entry.ClientName }}
                </th>
                <td class="align-middle text-table">
                  <span>{{ decimalToHoursAndMinutes(entry.Duration) }}</span>
                </td>
                <td
                  class="align-middle text-table"
                  style="width: 15% !important"
                >
                  {{ entry.ProjectTask }}
                </td>
                <td class="align-middle text-table">{{ entry.TestId }}</td>
                <td
                  class="align-middle text-table"
                  v-bind:class="{ 'text-danger': entry.CampaignTime > 7 }"
                >
                  <span v-if="entry.TestId !== ''">{{
                    decimalToHoursAndMinutes(entry.CampaignTime)
                  }}</span>
                </td>
                <td class="align-middle text-table">{{ entry.JiraID }}</td>
                <td class="align-middle text-table">{{ entry.EntityName }}</td>
                <td
                  class="align-middle text-table"
                  style="width: 25% !important"
                >
                  {{ entry.Description }}
                </td>
                <td class="align-middle text-table">{{ entry.ProductName }}</td>
                <td class="align-middle text-table">
                  {{ entry.Duplicate !== 0 ? entry.Duplicate : "" }}
                </td>
                <!-- <td class="align-middle">{{ entry.credit_use }}</td> -->
                <td class="align-middle text-table">
                  <span v-if="entry.ManDays === 0"></span
                  ><span v-else>{{ entry.ManDays }}</span>
                </td>
                <td v-if="isMobile">
                  <!-- make burger button to display  -->
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#entriesButtontModal"
                    class="btn btn-light"
                    @click="loadData(day, entryIndex, entry)"
                  >
                    ...
                  </button>
                </td>
                <td
                  class="align-middle"
                  style="
                    width: 75px;
                    width: 70px !important;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else
                >
                  <font-awesome-icon
                    icon="edit"
                    class="edit-button button-light me-2"
                    v-if="!isUserKam"
                    @click="
                      startEntryEdit(day, entryIndex, 'home');
                      goToForm();
                    "
                    color="transparent"
                  />
                  <font-awesome-icon
                    icon="trash-alt"
                    class="delete-button button-light"
                    v-if="!isUserKam"
                    @click="deleteEntry(entry, 'home').then(() => {
                      fetchUserEntries();
                    });"
                    color="transparent"
                  />
                  <font-awesome-icon
                    icon="copy"
                    class="copy-button button-light ms-2"
                    v-if="!isUserKam"
                    @click="
                      duplicateEntry(day, entryIndex, 'home');
                      goToForm();
                    "
                    color="transparent"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="entriesButtontModal"
      tabindex="-1"
      aria-labelledby="entriesButtontModal"
      aria-hiden="true"
      v-if="isHomePage"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn btn-primary"
              v-if="!isUserKam"
              @click="startEntryEdit(entriesDay, entryIndex, 'home')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Edit
            </button>
            <button
              type="button"
              class="btn btn-danger"
              v-if="!isUserKam"
              @click="deleteEntry(entryToDel, 'home')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Delete
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              v-if="!isUserKam"
              @click="duplicateEntry(entriesDay, entryIndex, 'home')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Duplicate
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="entriesButtontModal"
      tabindex="-1"
      aria-labelledby="entriesButtontModal"
      aria-hiden="true"
      v-else
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn btn-primary"
              v-if="!isUserKam"
              @click="startEntryEdit(entriesDay, entryIndex, 'client')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Edit
            </button>
            <button
              type="button"
              class="btn btn-danger"
              v-if="!isUserKam"
              @click="deleteEntry(entryToDel, 'client')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Delete
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              v-if="!isUserKam"
              @click="duplicateEntry(entriesDay, entryIndex, 'client')"
              data-bs-dismiss="modal"
              aria-label="close"
              color="transparent"
            >
              Duplicate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch, computed, onMounted } from "vue";
import { useFormStore } from "@/stores/form.js";
import { useUserStore } from "../stores/user";

// import fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faEdit, faTrashAlt, faCopy } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faEdit, faTrashAlt, faCopy);

const formStore = useFormStore();

const { startEntryEdit, deleteEntry, duplicateEntry } = formStore;

// set props for the component
let entriesProps = defineProps({
  entries: {
    type: Object,
    required: true,
  },
  renderType: {
    type: String,
    required: true,
  },
});

const { checkIfUserIsKam } = useUserStore;
const isUserKam = useUserStore().checkIfUserIsKam();

// set reactive entries
let entriesToDisp = reactive(entriesProps.entries);
// watch for changes in the entries prop and update the reactive entries
watch(
  () => entriesProps.entries,
  (newValues) => {
    entriesToDisp = newValues;
  },
);

// set render type
let renderType = ref(entriesProps.renderType);
// watch for changes in the render type prop and update the render type
watch(
  () => entriesProps.renderType,
  () => {
    renderType.value = entriesProps.renderType;
  },
);

// usefull functions to compute decimal hours to hours and minutes
const decimalToHoursAndMinutes = function (decimalTime) {
  if (decimalTime !== undefined && decimalTime !== null) {
    var hour = Math.floor(decimalTime);
    var minute = (decimalTime - hour) * 60;
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute;
  }
};

// set two emits to be used in the component
const eventEmiter = defineEmits(["goToForm", "destroyLastEntry"]);

// make the functions emitng an events to trigger te gotoform method in parent component
const goToForm = function () {
  eventEmiter("goToForm");
};

const forceCleaningEntries = function (day) {
  eventEmiter("destroyLastEntry", day);
};

const viewWidth = ref(window.innerWidth);
const viewHeight = ref(window.innerHeight);
const isMobile = ref(false);

watch(viewWidth, (newWidth, oldWidth) => {
  if (newWidth !== oldWidth) {
    if (320 <= newWidth && newWidth < 1024) {
      isMobile.value = true;
    }
  }
});
function handleResize() {
  viewWidth.value = window.innerWidth;
  viewHeight.value = window.innerHeight;
  if (320 <= viewWidth.value && viewWidth < 1024) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
}
window.addEventListener("resize", handleResize);

onMounted(async () => {
  handleResize();
});

const entriesDay = ref("");
const entryIndex = 0;
const entryToDel = ref({});
function loadData(day, entryIndex, entry) {
  entriesDay.value = day;
  entryToDel.value = entry;
  entryIndex = entryIndex;
}

const isHomePage = ref(true);

function checkIfUrlIsHomePage() {
  if (window.location.pathname === "/home") {
    isHomePage.value = true;
  } else {
    isHomePage.value = false;
  }
}

onMounted(() => {
  checkIfUrlIsHomePage();
});
</script>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "entriesHistory",
});
</script>

<style lang="scss">
.entries-history-wrapper {
  @media (min-width: 50px) {
    display: flex;
    flex-direction: row;

    width: max-content;
    height: max-content;
  }
  @media (min-width: 1024px) {
    width: 100%;
    margin-left: 2%;
    margin-right: 2%;
    display: flex;
    flex-direction: row;
    height: max-content;
  }
}

.date-title-entries {
  text-align: left;
  font-weight: bold;
  padding-left: 25px;
}

.enies-history-wrapper {
  @media (min-width: 50px) {
    margin-top: 5px;
  }
}

.table-scroll-entries {
  @media (min-width: 50px) {
    width: max-content;
    overflow-x: scroll;
  }
  @media (min-width: 1024px) {
    width: 94% !important;
    height: auto !important;
    overflow-x: hidden;
  }
}

.table-entry-home {
  @media (min-width: 50px) {
    overflow-x: scroll;
  }
  @media (min-width: 1024px) {
    width: 100%;
    table-layout: fixed;
    overflow: hidden;
  }
}

.text-header-table {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-header-table:hover {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}
.text-header-table-sm {
  @media (min-width: 1024px) {
    max-width: min-content !important;
  }
}

.text-table {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-table:hover {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  width: auto;
}

.description-cell {
  @media (min-width: 1024px) {
    width: max-content !important;
  }
}

.container-row.text-table:hover {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  width: auto;
}

.container-row:hover .edit-button {
  color: rgba(77, 157, 224, 1);
  cursor: pointer;
}

.container-row:hover .delete-button {
  color: rgba(225, 85, 84, 1);
  cursor: pointer;
}

.container-row:hover .copy-button {
  color: rgba(59, 178, 115, 1);
  cursor: pointer;
}

.clickable:hover {
  cursor: pointer;
}
</style>
